interface DisplayPriceProps {
    originalPrice?: Price;
    discountedPrice?: Price;
    minAddOnPrice?: Price;
    promoSavingPrice?: Price;
}

type BaseDisplayPriceResult = {
    originalPrice: Price;
    promoSavingPrice: Price;
};

type DisplayPriceResult =
    | (BaseDisplayPriceResult & {
          useDiscountedPrice: true;
          useAddOnPrice: true;
          minAddOnPrice: NonNullable<Price>;
          discountedPrice: NonNullable<Price>;
      })
    | (BaseDisplayPriceResult & {
          useDiscountedPrice: false;
          useAddOnPrice: false;
          discountedPrice: null;
          minAddOnPrice: null;
      })
    | (BaseDisplayPriceResult & {
          useAddOnPrice: true;
          useDiscountedPrice: false;
          minAddOnPrice: NonNullable<Price>;
          discountedPrice: null;
      })
    | (BaseDisplayPriceResult & {
          useAddOnPrice: false;
          useDiscountedPrice: true;
          minAddOnPrice: null;
          discountedPrice: NonNullable<Price>;
      });

function getDisplayPrice(props: DisplayPriceProps): DisplayPriceResult {
    const {
        originalPrice = null,
        discountedPrice = null,
        minAddOnPrice = null,
        promoSavingPrice = null,
    } = props;

    const useAddOnPrice = !!minAddOnPrice;

    const useDiscountedPrice =
        discountedPrice && discountedPrice.amount !== originalPrice?.amount;

    const _addOnPrice = useAddOnPrice
        ? {
              useAddOnPrice: true as const,
              minAddOnPrice: minAddOnPrice!,
          }
        : {
              useAddOnPrice: false as const,
              minAddOnPrice: null,
          };

    const _discountedPrice = useDiscountedPrice
        ? {
              useDiscountedPrice: true as const,
              discountedPrice: discountedPrice!,
          }
        : {
              useDiscountedPrice: false as const,
              discountedPrice: null,
          };

    return {
        ..._addOnPrice,
        ..._discountedPrice,
        originalPrice,
        promoSavingPrice,
    };
}

export { getDisplayPrice };
